import React, { useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import "../../../assets/css/gcstudent/getintouch/GetInTouch.css";

const GetInTouch = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Simulate API call — replace with Laravel backend later
    await new Promise((res) => setTimeout(res, 1200));
    setLoading(false);
    setSubmitted(true);
    setFormData({ fullName: "", email: "", subject: "", message: "" });
  };

  return (
    <section className="gcStudent-git-section" ref={sectionRef}>
      <Container>
        {/* Header */}
        <div
          className={`gcStudent-git-header ${
            isVisible ? "gcStudent-git-header--visible" : ""
          }`}
        >
          <h2 className="gcStudent-git-title">Get In Touch</h2>
          <p className="gcStudent-git-subtitle">
            Have questions? We'd love to hear from you.
          </p>
        </div>

        {/* Form Card */}
        <div
          className={`gcStudent-git-card ${
            isVisible ? "gcStudent-git-card--visible" : ""
          }`}
        >
          {submitted ? (
            /* Success State */
            <div className="gcStudent-git-success">
              <div className="gcStudent-git-success-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="11" stroke="#213b52" strokeWidth="1.8" />
                  <path
                    d="M7 12.5l3.5 3.5 6.5-7"
                    stroke="#213b52"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <h5 className="gcStudent-git-success-title">Message Sent!</h5>
              <p className="gcStudent-git-success-text">
                Thank you for reaching out. We'll get back to you soon.
              </p>
              <button
                className="gcStudent-git-submit"
                onClick={() => setSubmitted(false)}
              >
                Send Another Message
              </button>
            </div>
          ) : (
            /* Form */
            <form className="gcStudent-git-form" onSubmit={handleSubmit} noValidate>
              {/* Full Name */}
              <div className="gcStudent-git-field">
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Full Name"
                  className="gcStudent-git-input"
                  required
                />
              </div>

              {/* Email */}
              <div className="gcStudent-git-field">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  className="gcStudent-git-input"
                  required
                />
              </div>

              {/* Subject */}
              <div className="gcStudent-git-field">
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Subject"
                  className="gcStudent-git-input"
                  required
                />
              </div>

              {/* Message */}
              <div className="gcStudent-git-field">
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Your Message"
                  className="gcStudent-git-textarea"
                  rows={5}
                  required
                />
              </div>

              {/* Submit */}
              <button
                type="submit"
                className={`gcStudent-git-submit ${
                  loading ? "gcStudent-git-submit--loading" : ""
                }`}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="gcStudent-git-spinner" />
                    Sending...
                  </>
                ) : (
                  "Send Message"
                )}
              </button>
            </form>
          )}
        </div>
      </Container>
    </section>
  );
};

export default GetInTouch;